var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceRemote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "url(#paint0_linear_173_3453)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 38,
    height: 35,
    rx: 4,
    fill: "url(#paint1_linear_173_3453)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.0968 52.8921L53.2319 51.9013L53.0968 52.8921ZM22.9025 52.8921L22.7674 51.9013L22.9025 52.8921ZM19.4345 15.7089L19.6133 16.6928L19.4345 15.7089ZM56.5649 15.7089L56.386 16.6928L56.5649 15.7089ZM28.4238 62.6966C27.888 62.8306 27.5622 63.3735 27.6962 63.9093C27.8301 64.4451 28.3731 64.7709 28.9089 64.6369L28.4238 62.6966ZM32.3405 62.7482L32.098 61.7781L32.3405 62.7482ZM43.6588 62.7482L43.9014 61.7781L43.6588 62.7482ZM47.0905 64.6369C47.6263 64.7709 48.1692 64.4451 48.3032 63.9093C48.4371 63.3735 48.1113 62.8306 47.5755 62.6966L47.0905 64.6369ZM37.9997 62.0516V63.0516V62.0516ZM62.6663 24.218V43.6661H64.6663V24.218H62.6663ZM13.333 43.6661V24.218H11.333V43.6661H13.333ZM19.6133 16.6928C31.7712 14.4823 44.2281 14.4823 56.386 16.6928L56.7438 14.7251C44.3493 12.4715 31.65 12.4715 19.2556 14.7251L19.6133 16.6928ZM11.333 43.6661C11.333 49.9147 16.8464 54.7272 23.0376 53.883L22.7674 51.9013C17.777 52.5818 13.333 48.7027 13.333 43.6661H11.333ZM62.6663 43.6661C62.6663 48.7027 58.2224 52.5818 53.2319 51.9013L52.9617 53.883C59.153 54.7272 64.6663 49.9147 64.6663 43.6661H62.6663ZM64.6663 24.218C64.6663 19.555 61.3316 15.5592 56.7438 14.7251L56.386 16.6928C60.0228 17.354 62.6663 20.5215 62.6663 24.218H64.6663ZM13.333 24.218C13.333 20.5215 15.9765 17.354 19.6133 16.6928L19.2556 14.7251C14.6678 15.5592 11.333 19.555 11.333 24.218H13.333ZM28.9089 64.6369L32.583 63.7184L32.098 61.7781L28.4238 62.6966L28.9089 64.6369ZM43.4163 63.7184L47.0905 64.6369L47.5755 62.6966L43.9014 61.7781L43.4163 63.7184ZM38.9997 61.3334V54.3334H36.9997V61.3334H38.9997ZM53.2319 51.9013C48.1779 51.2121 43.0888 50.8675 37.9997 50.8675V52.8675C42.9985 52.8675 47.9973 53.206 52.9617 53.883L53.2319 51.9013ZM37.9997 50.8675C32.9106 50.8675 27.8214 51.2121 22.7674 51.9013L23.0376 53.883C28.002 53.206 33.0008 52.8675 37.9997 52.8675V50.8675ZM38.9997 54.3334V51.8675H36.9997V54.3334H38.9997ZM32.583 63.7184C34.3612 63.2738 36.1804 63.0516 37.9997 63.0516V61.0516C36.0175 61.0516 34.0354 61.2937 32.098 61.7781L32.583 63.7184ZM37.9997 63.0516C39.8189 63.0516 41.6381 63.2738 43.4163 63.7184L43.9014 61.7781C41.964 61.2937 39.9818 61.0516 37.9997 61.0516V63.0516ZM36.9997 61.3334V62.0516H38.9997V61.3334H36.9997Z",
    fill: "#070707"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_3453",
    x1: 69.6667,
    y1: 60.1667,
    x2: 0.0000165534,
    y2: 14.6458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE73C",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_3453",
    x1: 31.7059,
    y1: 38.3889,
    x2: 58.5294,
    y2: 38.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE73C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRemote);
export default __webpack_public_path__ + "static/media/service_remote.b91ccf274c7bd0d8b26372e1dc0e43e0.svg";
export { ForwardRef as ReactComponent };